import React, { useState } from 'react'
import styles from './SliceItem.module.css'

export const SliceItem = (props) => {
    const [active, setActive] = useState(false)
    // const regex = new RegExp('(?=[_])|(?<=[])', 'g')
    const slices = props.slice.split(/(_[a-z,A-Z,0-9]+)/)
    // const slices = props.slice.split(regex)

    const handleClick = (slice) => {
        props.handleClick(slice)
        setActive(prev => !prev)
    }

    if (slices.length > 1) {
        return <span className={active ? `${styles.block} ${styles.block_active}` : styles.block} onClick={() => handleClick(props.slice)}>
            <span id='alt1' className={active ? `${styles.subblock} ${styles.subblock_background_transparent}` : styles.subblock}>
                <p>{slices[0]}</p>
            </span>
            <span id='alt2' className={!active ? `${styles.subblock} ${styles.subblock_background_transparent}` : styles.subblock}>
                <p>{slices[0] + slices[1]}</p>
            </span>
        </span>
    }

    return <span className={styles.block}>
        <span className={styles.subblock}>
            <p>{slices[0]}</p>
        </span>
    </span>
}